import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = { class: "settings-card" }
const _hoisted_3 = {
  key: 0,
  class: "storage-loading"
}
const _hoisted_4 = {
  key: 1,
  class: "storage-error"
}
const _hoisted_5 = { class: "storage-bar-wrap" }
const _hoisted_6 = { class: "storage-label" }
const _hoisted_7 = {
  key: 0,
  class: "storage-warn"
}
const _hoisted_8 = {
  key: 1,
  class: "storage-breakdown"
}
const _hoisted_9 = { class: "sb-name" }
const _hoisted_10 = { class: "sb-val" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"card-header\" data-v-1f3cf35e><div class=\"card-icon\" data-v-1f3cf35e><svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1f3cf35e><ellipse cx=\"12\" cy=\"5\" rx=\"9\" ry=\"3\" data-v-1f3cf35e></ellipse><path d=\"M21 12c0 1.66-4 3-9 3s-9-1.34-9-3\" data-v-1f3cf35e></path><path d=\"M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5\" data-v-1f3cf35e></path></svg></div><div data-v-1f3cf35e><h3 class=\"card-title\" data-v-1f3cf35e>Armazenamento</h3><p class=\"card-desc\" data-v-1f3cf35e>Uso de espaço desta obra. O limite é definido pelo administrador geral.</p></div></div>", 1)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Carregando..."))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.error), 1))
          : (_ctx.status)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: "storage-bar-fill",
                    style: _normalizeStyle({ width: Math.min(100, _ctx.status.pct) + '%', background: _ctx.barColor })
                  }, null, 4)
                ]),
                _createElementVNode("p", _hoisted_6, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatMb(_ctx.status.usedMb)), 1),
                  _createTextVNode(" usados de " + _toDisplayString(_ctx.formatMb(_ctx.status.limitMb)) + " (" + _toDisplayString(Math.round(_ctx.status.pct)) + "%) ", 1)
                ]),
                (_ctx.status.pct >= 90)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Armazenamento quase cheio. Exclua arquivos/manuais antigos ou solicite aumento de limite ao administrador geral. "))
                  : _createCommentVNode("", true),
                (_ctx.breakdownItems.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breakdownItems, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.key,
                          class: "sb-row"
                        }, [
                          _createElementVNode("span", {
                            class: "sb-dot",
                            style: _normalizeStyle({ background: item.color })
                          }, null, 4),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(item.label), 1),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formatMb(item.mb)), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn-refresh",
                  type: "button",
                  disabled: _ctx.loading,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("svg", {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }, [
                    _createElementVNode("polyline", { points: "23 4 23 10 17 10" }),
                    _createElementVNode("path", { d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10" })
                  ], -1),
                  _createTextVNode(" Atualizar ", -1)
                ]))], 8, _hoisted_11)
              ], 64))
            : _createCommentVNode("", true)
    ])
  ]))
}